<template>
  <div>
    <!-- 닫힌 상태일 때 열기 버튼 -->
    <button v-if="isClosed" class="open-banner-btn" :style="{ top: bannerTop + 'px' }" @click="openBanner" title="판매자센터 열기">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 512 512">
        <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/>
      </svg>
      <span>판매자센터</span>
    </button>

    <!-- 플로팅 배너 -->
    <div v-if="!isClosed" class="floating-banner" :class="{ collapsed: isCollapsed, dragging: isDragging }" :style="{ top: bannerTop + 'px', left: bannerLeft + 'px', right: bannerRight ? bannerRight + 'px' : 'auto' }">
    <div class="banner-header" @mousedown="startDrag" :style="{ cursor: isDragging ? 'grabbing' : 'grab' }">
      <h4 class="banner-title">판매자센터</h4>
      <div class="banner-controls">
        <button class="control-btn" @click="toggleCollapse" :title="isCollapsed ? '펼치기' : '접기'">
          <svg v-if="isCollapsed" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 512 512">
            <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/>
          </svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 512 512">
            <path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"/>
          </svg>
        </button>
        <button class="control-btn close-btn" @click="closeBanner" title="닫기">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 384 512">
            <path d="M324.5 411.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 256 347.1 123.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4 59.5 100.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256 36.9 388.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 278.6 324.5 411.1z"/>
          </svg>
        </button>
      </div>
    </div>
    <div class="banner-content" v-show="!isCollapsed">
      <div class="link-list">
        <a
          v-for="(link, index) in sellerLinks"
          :key="index"
          :href="link.url"
          target="_blank"
          class="seller-link"
        >
          <img
            class="link-logo"
            :src="`/assets/images/app/marketLogo/${link.logo}.svg`"
            :alt="link.name"
          />
          <span class="link-text">{{ link.name }}</span>
          <svg class="external-icon" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 512 512">
            <path d="M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"/>
          </svg>
        </a>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: 'SellerCenterFloatingBanner',
  data() {
    return {
      isCollapsed: false,
      isClosed: false,
      bannerTop: 80, // 기본값: 헤더(60px) + 여백(20px)
      bannerLeft: null, // 드래그로 이동한 경우 left 위치
      bannerRight: 20, // 기본 right 위치
      isDragging: false,
      dragStartX: 0,
      dragStartY: 0,
      dragStartLeft: 0,
      dragStartTop: 0,
      sellerLinks: [
        // logo: src/assets/images/app/marketLogo/{logo}.svg (빌드 시 /assets/images 로 복사됨)
        { name: '쿠팡', logo: 'Coupang', url: 'https://wing.coupang.com/' },
        { name: '스마트스토어', logo: 'SmartStore_API', url: 'https://sell.smartstore.naver.com/' },
        { name: '지마켓', logo: 'Gmarket', url: 'https://signin.esmplus.com/login' },
        { name: '옥션', logo: 'Auction', url: 'https://signin.esmplus.com/login' },
        { name: '11번가', logo: 'Elevenst', url: 'https://login.11st.co.kr/auth/front/selleroffice/login.tmall' },
        { name: '롯데온', logo: 'LotteOn_API', url: 'https://store.lotteon.com/cm/main/login_SO.wsp' },
        { name: 'SSG', logo: 'SSG', url: 'https://po.ssgadm.com/authentication/login.ssg?retUrl=https://po.ssgadm.com/' },
        { name: '이베이', logo: 'Ebay', url: 'https://www.ebay.com/sl/sell' },
        { name: '쇼피', logo: 'ShopeeGlobal', url: 'https://seller.shopee.kr/account/signin?next=%2F' },
        { name: 'Qoo10', logo: 'Qoo10', url: 'https://qsm.qoo10.jp/gmkt.inc.gsm.web/login.aspx' },
        { name: '카페24', logo: 'Cafe24', url: 'https://user.cafe24.com/kr/join/ec/?action=joinForm&returnUrl=&cloud=' },
        { name: 'SHEIN', logo: 'Shein', url: 'https://sellerhub.shein.com/#/auth/GMPSSO/aHR0cHM6Ly9zZWxsZXJodWIuc2hlaW4uY29tLw==' },
        { name: '토스쇼핑', logo: 'TossShopping', url: 'https://shopping-seller.toss.im/' },
        { name: '카카오쇼핑', logo: 'KakaoShopping', url: 'https://shopping-sell.kakao.com/' },
        { name: '도매꾹', logo: 'Domeggook', url: 'https://domeggook.com/main/mySell/my_sellMain.php' }
      ]
    };
  },
  mounted() {
    // 현재 로그인한 사용자 ID 확인
    const currentUserId = localStorage.getItem('loginUserId');
    const savedUserId = localStorage.getItem('sellerCenterBannerUserId');
    
    // 사용자가 변경되었거나 재로그인한 경우 접힌 상태 초기화
    if (currentUserId && currentUserId !== savedUserId) {
      // 새로운 사용자이거나 재로그인한 경우 접힌 상태 초기화
      localStorage.removeItem('sellerCenterBannerCollapsed');
      localStorage.setItem('sellerCenterBannerUserId', currentUserId);
      this.isCollapsed = false;
    } else if (currentUserId) {
      // 같은 사용자인 경우 저장된 접힌 상태 확인
      const collapsedState = localStorage.getItem('sellerCenterBannerCollapsed');
      if (collapsedState === 'true') {
        this.isCollapsed = true;
      }
    } else {
      // 로그인하지 않은 경우 (랜딩 페이지 등)
      const collapsedState = localStorage.getItem('sellerCenterBannerCollapsed');
      if (collapsedState === 'true') {
        this.isCollapsed = true;
      }
    }
    
    // localStorage에서 닫힌 상태 확인
    const closedState = localStorage.getItem('sellerCenterBannerClosed');
    if (closedState === 'true') {
      this.isClosed = true;
    }

    // 헤더 높이 계산
    this.calculateBannerTop();
    
    // 저장된 위치 불러오기
    this.loadBannerPosition();
    
    // 윈도우 리사이즈 시 재계산
    window.addEventListener('resize', this.calculateBannerTop);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.calculateBannerTop);
    window.removeEventListener('mousemove', this.onDrag);
    window.removeEventListener('mouseup', this.stopDrag);
  },
  methods: {
    calculateBannerTop() {
      // 저장된 위치가 없을 때만 자동 계산
      if (this.bannerLeft === null) {
        // 헤더 높이 계산
        const header = document.querySelector('.header_wrap');
        const extensionWarning = document.querySelector('.extension-warning');
        
        let headerHeight = 60; // 기본 헤더 높이
        let extensionHeight = 0;
        
        if (header) {
          headerHeight = header.offsetHeight;
        }
        
        if (extensionWarning && extensionWarning.offsetParent !== null) {
          extensionHeight = extensionWarning.offsetHeight;
        }
        
        // 헤더 + 탑퍼 + 여백(20px)
        this.bannerTop = headerHeight + extensionHeight + 20;
      }
    },
    loadBannerPosition() {
      // 저장된 위치 불러오기
      const savedLeft = localStorage.getItem('sellerCenterBannerLeft');
      const savedTop = localStorage.getItem('sellerCenterBannerTop');
      
      if (savedLeft !== null) {
        this.bannerLeft = parseInt(savedLeft, 10);
        this.bannerRight = null; // left를 사용하면 right는 null
      }
      
      if (savedTop !== null) {
        this.bannerTop = parseInt(savedTop, 10);
      }
    },
    saveBannerPosition() {
      // 위치 저장
      if (this.bannerLeft !== null) {
        localStorage.setItem('sellerCenterBannerLeft', this.bannerLeft.toString());
        localStorage.setItem('sellerCenterBannerTop', this.bannerTop.toString());
      }
    },
    startDrag(e) {
      // 버튼 클릭 시 드래그 방지
      if (e.target.closest('button')) {
        return;
      }
      
      this.isDragging = true;
      this.dragStartX = e.clientX;
      this.dragStartY = e.clientY;
      
      // 현재 위치 저장
      if (this.bannerLeft === null) {
        // 처음 드래그하는 경우 현재 right 위치를 left로 변환
        const banner = this.$el.querySelector('.floating-banner');
        if (banner) {
          const rect = banner.getBoundingClientRect();
          this.bannerLeft = rect.left;
          this.bannerRight = null;
        }
      }
      
      this.dragStartLeft = this.bannerLeft || 0;
      this.dragStartTop = this.bannerTop;
      
      // 전역 이벤트 리스너 추가
      window.addEventListener('mousemove', this.onDrag);
      window.addEventListener('mouseup', this.stopDrag);
      
      // 텍스트 선택 방지
      e.preventDefault();
    },
    onDrag(e) {
      if (!this.isDragging) return;
      
      const deltaX = e.clientX - this.dragStartX;
      const deltaY = e.clientY - this.dragStartY;
      
      // 새 위치 계산
      let newLeft = this.dragStartLeft + deltaX;
      let newTop = this.dragStartTop + deltaY;
      
      // 화면 경계 체크
      const banner = this.$el.querySelector('.floating-banner');
      if (banner) {
        const bannerWidth = banner.offsetWidth;
        const bannerHeight = banner.offsetHeight;
        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;
        
        // 좌우 경계
        newLeft = Math.max(0, Math.min(newLeft, windowWidth - bannerWidth));
        
        // 상하 경계 (헤더 아래부터)
        const header = document.querySelector('.header_wrap');
        const extensionWarning = document.querySelector('.extension-warning');
        let minTop = 60; // 기본 헤더 높이
        if (header) {
          minTop = header.offsetHeight;
        }
        if (extensionWarning && extensionWarning.offsetParent !== null) {
          minTop += extensionWarning.offsetHeight;
        }
        
        newTop = Math.max(minTop, Math.min(newTop, windowHeight - bannerHeight));
      }
      
      this.bannerLeft = newLeft;
      this.bannerTop = newTop;
      this.bannerRight = null; // left를 사용하면 right는 null
    },
    stopDrag() {
      if (this.isDragging) {
        this.isDragging = false;
        this.saveBannerPosition();
        
        // 전역 이벤트 리스너 제거
        window.removeEventListener('mousemove', this.onDrag);
        window.removeEventListener('mouseup', this.stopDrag);
      }
    },
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
      localStorage.setItem('sellerCenterBannerCollapsed', this.isCollapsed.toString());
    },
    closeBanner() {
      this.isClosed = true;
      localStorage.setItem('sellerCenterBannerClosed', 'true');
    },
    openBanner() {
      this.isClosed = false;
      localStorage.removeItem('sellerCenterBannerClosed');
      // 열 때 헤더 높이 재계산
      this.$nextTick(() => {
        this.calculateBannerTop();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
// 열기 버튼 스타일
.open-banner-btn {
  position: fixed;
  top: 80px; // 기본값: 헤더(60px) + 여백(20px)
  right: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #a855f7 100%);
  color: #ffffff;
  border: none;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(99, 102, 241, 0.3);
  cursor: pointer;
  z-index: 9998;
  font-size: 13px;
  font-weight: 600;
  font-family: 'MinSans-Regular', 'sans-serif';
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;

  svg {
    fill: #ffffff;
    width: 16px;
    height: 16px;
    transform: rotate(-90deg);
  }

  &:hover {
    box-shadow: 0 6px 20px rgba(99, 102, 241, 0.4);
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
}

.floating-banner {
  position: fixed;
  width: 168px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08);
  z-index: 9998;
  transition: box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  font-family: 'MinSans-Regular', 'sans-serif';
  user-select: none; // 드래그 시 텍스트 선택 방지

  &:hover {
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15), 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  &.dragging {
    transition: none; // 드래그 중에는 transition 비활성화
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.2), 0 6px 16px rgba(0, 0, 0, 0.15);
    cursor: grabbing;
  }

  &.collapsed {
    // 접힌 상태에서도 헤더는 항상 보임
    .banner-header {
      display: flex;
    }
    
    .banner-content {
      max-height: 0;
      opacity: 0;
      padding: 0;
      overflow: hidden;
    }
  }

  .banner-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 16px;
    background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #a855f7 100%);
    color: #ffffff;
    position: relative;
    overflow: hidden;
    cursor: grab; // 드래그 가능 표시

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 100%);
      pointer-events: none;
    }

    .banner-title {
      margin: 0;
      font-size: 13px;
      font-weight: 600;
      letter-spacing: -0.3px;
      position: relative;
      z-index: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .banner-controls {
      display: flex;
      gap: 6px;
      position: relative;
      z-index: 1;

      .control-btn {
        background: rgba(255, 255, 255, 0.15);
        border: none;
        border-radius: 6px;
        width: 26px;
        height: 26px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
        padding: 0;
        backdrop-filter: blur(4px);

        svg {
          fill: #ffffff;
          width: 14px;
          height: 14px;
          transition: transform 0.2s ease;
        }

        &:hover {
          background: rgba(255, 255, 255, 0.25);
          transform: scale(1.05);
          
          svg {
            transform: scale(1.1);
          }
        }

        &:active {
          transform: scale(0.95);
        }

        &.close-btn:hover {
          background: rgba(239, 68, 68, 0.3);
        }
      }
    }
  }

  .banner-content {
    max-height: 480px;
    opacity: 1;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    overflow-y: auto;
    background: linear-gradient(to bottom, #fafafa 0%, #ffffff 100%);

    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      transition: background 0.2s ease;

      &:hover {
        background: rgba(0, 0, 0, 0.3);
      }
    }

    .link-list {
      padding: 10px;
      display: flex;
      flex-direction: column;
      gap: 6px;

      .seller-link {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 12px;
        background: #ffffff;
        border-radius: 8px;
        text-decoration: none;
        color: #111827;
        font-size: 13px;
        font-weight: 500;
        transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        border: 1px solid rgba(229, 231, 235, 0.8);
        position: relative;
        overflow: hidden;

        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          width: 0;
          background: linear-gradient(90deg, rgba(99, 102, 241, 0.1) 0%, rgba(139, 92, 246, 0.1) 100%);
          transition: width 0.3s ease;
        }

        .link-logo {
          position: relative;
          z-index: 1;
          width: 18px;
          height: 18px;
          object-fit: contain;
          flex-shrink: 0;
          margin-right: 8px;
        }

        .link-text {
          position: relative;
          z-index: 1;
          flex: 1;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .external-icon {
          position: relative;
          z-index: 1;
          fill: #9ca3af;
          transition: all 0.2s ease;
          flex-shrink: 0;
          margin-left: 8px;
        }

        &:hover {
          background: linear-gradient(135deg, #f3f4f6 0%, #ffffff 100%);
          border-color: #6366f1;
          color: #6366f1;
          transform: translateX(-3px);
          box-shadow: 0 2px 8px rgba(99, 102, 241, 0.15);

          &::before {
            width: 100%;
          }

          .external-icon {
            fill: #6366f1;
            transform: translate(2px, -2px);
          }
        }

        &:active {
          transform: translateX(-2px) scale(0.98);
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .open-banner-btn {
    top: 80px;
    right: 10px;
    padding: 8px 12px;
    font-size: 12px;

    svg {
      width: 14px;
      height: 14px;
    }
  }

  .floating-banner {
    width: 144px;
    right: 10px;
    border-radius: 10px;

    .banner-header {
      padding: 12px 14px;

      .banner-title {
        font-size: 13px;
      }

      .banner-controls {
        gap: 4px;

        .control-btn {
          width: 24px;
          height: 24px;

          svg {
            width: 12px;
            height: 12px;
          }
        }
      }
    }

    .banner-content {
      .link-list {
        padding: 8px;
        gap: 5px;

        .seller-link {
          padding: 8px 10px;
          font-size: 13px;

          .link-logo {
            width: 16px;
            height: 16px;
            margin-right: 6px;
          }

          .external-icon {
            width: 10px;
            height: 10px;
          }
        }
      }
    }
  }
}
</style>
